import React, { useEffect, useMemo } from 'react';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import styles from './styles/styles.module.scss';
import MainPane from '../layout/MainPane';
import Feed from '../Feed';
import { getFeedOptions, getActiveFeed, updateActiveFeedKey } from '../../ducks/feeds';
import { openConnectModal } from '../../ducks/connectFlow';
import FeedHeader from '../FeedHeader';
import { useHistory, useParams } from 'react-router-dom';
import FeedShimmer from '../shimmers/FeedShimmer';
import { IDLE, LOADING, SUCCEEDED } from '../../constants';

const FeedPane = () => {
  const dispatch = useDispatch();
  const { activeFeedKey, feeds, feedOptions, requestState } = useSelector(state => state.feeds, shallowEqual);
  const { windowWidth } = useSelector(state => state.browserWindow, shallowEqual);
  const { feedKey } = useParams();
  const history = useHistory();

  const updatePath = () => {
    if (feedKey === activeFeedKey) return;

    history.push(`/community/feeds/${activeFeedKey}`);
  };

  useEffect(() => {
    dispatch(getFeedOptions(feedKey));
  }, []);

  useEffect(() => {
    if (!activeFeedKey) {
      return;
    }

    dispatch(getActiveFeed());
    updatePath();
  }, [activeFeedKey]);

  const activeFeed = useMemo(() => {
    if (!activeFeedKey) {
      return null;
    }

    return feeds.find(feed => feed.key === activeFeedKey);
  }, [activeFeedKey, feeds]);

  const handleActiveFeedChange = idx => {
    const { name } = feedOptions[idx];

    dispatch(updateActiveFeedKey(name));
  };

  const showFeed = activeFeed || requestState === SUCCEEDED;

  return (
    <MainPane>
      <FeedHeader
        activeFeedKey={activeFeedKey}
        feedOptions={feedOptions}
        handleActiveFeedChange={handleActiveFeedChange}
        windowWidth={windowWidth}
        dispatchCommunityModal={() => dispatch(openConnectModal())}
      />
      <div className={styles.feedContainer}>{showFeed ? <Feed feed={activeFeed} /> : <FeedShimmer />}</div>
    </MainPane>
  );
};

export default FeedPane;
